<template>
  <div> 
      <div class="row">   
        <div class="col-xs-12 col-md-1" >            
            
        </div>
        <div class="col-xs-12 col-md-11" > 
            <router-view></router-view>                       
        </div>
      </div>      
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
       
    }
  },
  created: function () {            
   
  },
  mounted: function () {        
    
  },
  methods: {
    
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// AdminMain.vue?26fbfaef